import { render, staticRenderFns } from "./CartsListFilters.vue?vue&type=template&id=2620692a"
import script from "./CartsListFilters.vue?vue&type=script&lang=js"
export * from "./CartsListFilters.vue?vue&type=script&lang=js"
import style0 from "./CartsListFilters.vue?vue&type=style&index=0&id=2620692a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports